
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart3, PieChart, LineChart, TrendingUp, Calendar, Users, Activity, DollarSign } from "lucide-react";
import { Link } from "react-router-dom";

interface ReportCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  link?: string;
}

const ReportCard: React.FC<ReportCardProps> = ({ title, description, icon, link }) => {
  const cardContent = (
    <>
      <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
        <CardTitle className="text-xl font-bold">{title}</CardTitle>
        <div className="rounded-full bg-secondary p-2 text-primary">
          {icon}
        </div>
      </CardHeader>
      <CardContent>
        <CardDescription className="text-sm text-gray-500">{description}</CardDescription>
      </CardContent>
    </>
  );

  if (link) {
    return (
      <Link to={link} className="block">
        <Card className="hover:shadow-md transition-shadow">
          {cardContent}
        </Card>
      </Link>
    );
  }

  return (
    <Card className="hover:shadow-md transition-shadow">
      {cardContent}
    </Card>
  );
};

const Reports = () => {
  const reportsList = [
    {
      title: "Pace Report",
      description: "Compare property performance to the previous year",
      icon: <DollarSign className="h-5 w-5" />,
      link: "/reports/rmspace"
    },
    // {
    //   title: "Occupancy Rates",
    //   description: "Analysis of property occupancy rates over time with trends and forecasts.",
    //   icon: <BarChart3 className="h-5 w-5" />
    // },
    // {
    //   title: "Revenue Distribution",
    //   description: "Breakdown of revenue sources across different properties and categories.",
    //   icon: <PieChart className="h-5 w-5" />
    // },
    // {
    //   title: "Performance Trends",
    //   description: "Long-term performance trends across all properties and business metrics.",
    //   icon: <TrendingUp className="h-5 w-5" />
    // },
    // {
    //   title: "Seasonal Analysis",
    //   description: "Seasonal patterns in occupancy, pricing, and revenue for strategic planning.",
    //   icon: <Calendar className="h-5 w-5" />
    // },
    // {
    //   title: "Customer Demographics",
    //   description: "Insights into customer demographics, preferences, and booking patterns.",
    //   icon: <Users className="h-5 w-5" />
    // },
    // {
    //   title: "Maintenance Tracking",
    //   description: "Tracking property maintenance costs, frequency, and impact on operations.",
    //   icon: <Activity className="h-5 w-5" />
    // },
    // {
    //   title: "Market Comparison",
    //   description: "Benchmark your properties against market standards and competitors.",
    //   icon: <LineChart className="h-5 w-5" />
    // }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="pt-0 pb-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center sm:justify-between py-6">
            <h1 className="text-2xl font-semibold text-gray-900">Reports</h1>
            <p className="mt-2 text-sm text-gray-700 sm:mt-0">
              Access and generate various reports for your business
            </p>
          </div>
        </div>
      </div>

      <main className="pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {reportsList.map((report, index) => (
              <ReportCard 
                key={index}
                title={report.title}
                description={report.description}
                icon={report.icon}
                link={report.link}
              />
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Reports;
